import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";

const SECOES = [
  { rotulo: "Recursos", ancora: "recursos" },
  { rotulo: "Recompra", ancora: "recompra" },
  { rotulo: "Para quem", ancora: "para-quem" },
];

export function Topo() {
  const [aberto, setAberto] = useState(false);
  const { pathname } = useLocation();
  // Na landing a ancora rola a pagina; fora dela, leva de volta para a secao.
  const prefixo = pathname === "/" ? "" : "/";

  return (
    <header className="lp-topo">
      <Link to="/" className="lp-marca">
        Samev
      </Link>

      <nav
        aria-label="Menu do site"
        className={cn("lp-menu", aberto && "lp-menu-aberto")}
        onClick={() => setAberto(false)}
      >
        {SECOES.map((s) => (
          <a key={s.ancora} href={`${prefixo}#${s.ancora}`} className="lp-topo-link">
            {s.rotulo}
          </a>
        ))}
        {/* <a>, nao <Link>: o blog e servido pelo servidor, fora do roteador da SPA. */}
        <a href="/blog" className="lp-topo-link">
          Blog
        </a>
        <Link to="/afiliados" className="lp-topo-link">
          Afiliados
        </Link>
      </nav>

      <div className="lp-topo-acoes">
        <Link to="/entrar" className="lp-btn lp-btn-secundario lp-btn-pequeno">
          Entrar
        </Link>
        <Link to="/criar-conta" className="lp-btn lp-btn-principal lp-btn-pequeno">
          Criar conta
        </Link>
        <button
          type="button"
          className="lp-menu-abrir"
          aria-label={aberto ? "Fechar menu" : "Abrir menu"}
          aria-expanded={aberto}
          onClick={() => setAberto((v) => !v)}
        >
          {aberto ? <X size={18} aria-hidden /> : <Menu size={18} aria-hidden />}
        </button>
      </div>
    </header>
  );
}
